import script from "./HeadComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadComponent.vue?vue&type=script&setup=true&lang=js"

import "./HeadComponent.vue?vue&type=style&index=0&id=392e9eda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392e9eda"]])

export default __exports__